import React from 'react';

export interface FormField {
  key: string;
  label: string;
  type: 'text' | 'select' | 'number' | 'email' | 'tel';
  placeholder?: string;
  options?: { value: string; label: string }[];
  required?: boolean;
  disabled?: boolean;
}

export interface GenericFormProps<T> {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  data: T | Partial<T>;
  fields: FormField[];
  onFieldChange: (field: keyof T, value: any) => void;
  onSave: () => void;
  saveText?: string;
}

export interface ValidationErrors {
  [key: string]: string;
}

export interface FieldGroups {
  personalFields: FormField[];
  workFields: FormField[];
  authFields: FormField[];
}

export type FieldCategory = 'personal' | 'work' | 'auth';

export interface FieldGroupConfig {
  category: FieldCategory;
  title: string;
  gradientClass: string;
  borderClass: string;
  fields: FormField[];
}

export interface UseFormValidationReturn {
  validationErrors: ValidationErrors;
  validateForm: () => boolean;
  clearValidationErrors: () => void;
  clearFieldError: (fieldKey: string) => void;
  setValidationErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>;
}

export interface UseFieldFormattingReturn {
  formatDisplayValue: (value: string, fieldKey: string) => string;
  formatInputValue: (value: string, fieldKey: string) => string;
  isValidInput: (value: string, fieldKey: string) => boolean;
}

export interface FormFieldRendererProps<T> {
  field: FormField;
  data: T | Partial<T>;
  onFieldChange: (field: keyof T, value: any) => void;
  validationError?: string;
  onClearError: (fieldKey: string) => void;
}

export interface FormFieldGroupProps<T> {
  config: FieldGroupConfig;
  data: T | Partial<T>;
  onFieldChange: (field: keyof T, value: any) => void;
  validationErrors: ValidationErrors;
  onClearError: (fieldKey: string) => void;
}

export const personalFieldKeys = ['name', 'surname', 'phone_number', 'identification_number'];
export const workFieldKeys = ['management', 'office'];
export const authFieldKeys = ['authorization_level'];

export const fieldCategoryConfigs: Record<FieldCategory, Omit<FieldGroupConfig, 'fields'>> = {
  personal: {
    category: 'personal',
    title: 'Kişisel Bilgiler',
    gradientClass: 'from-blue-50 to-purple-50',
    borderClass: 'border-blue-100',
  },
  work: {
    category: 'work',
    title: 'İş Bilgileri',
    gradientClass: 'from-green-50 to-emerald-50',
    borderClass: 'border-green-100',
  },
  auth: {
    category: 'auth',
    title: 'Yetki Bilgileri',
    gradientClass: 'from-orange-50 to-yellow-50',
    borderClass: 'border-orange-100',
  },
};
